/**
 * 指定セレクターの要素の高さを揃える
 * @param {string} selector - CSSセレクター（デフォルト: '.match-height'）
 */
function matchHeight(selector = '.match-height') {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  // 高さをリセット
  elements.forEach(el => el.style.height = '');

  let maxHeight = 0;
  elements.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  elements.forEach(el => {
    el.style.height = `${maxHeight}px`;
  });
}

window.matchHeight = matchHeight;

async function getNews() {
  const res = await fetch('/common/mock/newsList.json');
  const json = await res.json();
  const rawList = json.rt_news_list || [];

  return rawList.map(item => ({
    href: item.href || '#',
    type: item.rt_cf_type || 'normal',
    date: item.rt_cf_date || '',
    title: item.rt_cf_title || '',
    category: item.rt_cf_category || null,
    pdf: item.rt_cf_pdf || false,
    pdfSize: item.rt_cf_pdf_size || '',
    blank: item.rt_cf_blank || false,
  }));
}

window.getNews = getNews;

/**
 * data-match-height 属性によるグループ別高さ揃え自動実行
 * 同じグループ名を持つ要素同士で高さを揃える
 * 例: <div data-match-height="card-title">...</div>
 */
function initMatchHeight() {
  const elements = document.querySelectorAll('[data-match-height]');
  if (!elements.length) return;

  // グループ名で分類
  const groups = {};
  elements.forEach(el => {
    const group = el.getAttribute('data-match-height');
    if (!groups[group]) groups[group] = [];
    groups[group].push(el);
  });

  // グループごとに行単位で高さ揃え（段落ちした要素は別行として扱う）
  Object.values(groups).forEach(els => {
    els.forEach(el => el.style.height = '');

    // offsetTopで行を判定
    const rows = [];
    let currentRow = [];
    let currentTop = null;

    els.forEach(el => {
      const top = el.getBoundingClientRect().top;
      if (currentTop === null || Math.abs(top - currentTop) > 1) {
        if (currentRow.length) rows.push(currentRow);
        currentRow = [el];
        currentTop = top;
      } else {
        currentRow.push(el);
      }
    });
    if (currentRow.length) rows.push(currentRow);

    // 行ごとに高さを揃える（1要素だけの行はスキップ）
    rows.forEach(row => {
      if (row.length <= 1) return;

      let maxHeight = 0;
      row.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });

      row.forEach(el => {
        el.style.height = `${maxHeight}px`;
      });
    });
  });
}

window.addEventListener('DOMContentLoaded', initMatchHeight);
window.addEventListener('resize', initMatchHeight);

// ニュースルーム 検索ブロック 展開/折りたたみ・クリア
(function() {
  const a = 'is-active';
  const v = 'is-visible';
	const f = 'is-fixed';

  // 汎用モーダル
  function setModal() {
    const createModal = (_appendHTML, _target) => {
      const $container = document.createElement('div');
      $container.className = 'mod-modal-overlay';
      $container.innerHTML = _appendHTML;
      document.body.appendChild($container);

      $container.classList.add(a);
      setTimeout(() => {
        $container.classList.add(v);
        
        // YouTube動画モーダルの場合iframe部分のクリックを無効化
        var movieModal = $container.querySelector('.mod-modalContent_inner._movie');
        if (movieModal) {
          movieModal.addEventListener('click', function(e) {
            e.stopPropagation();
          });
        }
        
        document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
          ele.addEventListener('click', (e) => {
            $container.classList.remove(v);
            setTimeout(() => {
              $container.classList.remove(a);
              $container.remove();
              _target.focus({ preventScroll: true });
            }, 400);
          });
        });
        window.addEventListener("keydown", function (event) {
          if (document.querySelectorAll('.mod-modal-overlay').length) {
            // タブキーが押された時
            if (event.key === "Tab") {
              event.preventDefault();
              // モーダル要素内のフォーカス可能な要素の一覧を取得
              const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
              const focusableElements = Array.from(
                document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
              );
              // 現在のフォーカス位置を取得
              const focusedItemIndex = focusableElements.indexOf(document.activeElement);
              // shiftキーと同時に押されてた場合
              if (event.shiftKey) {
                if (focusedItemIndex === 0) {
                  // 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
                  focusableElements[focusableElements.length - 1].focus();
                } else {
                  // 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
                  focusableElements[focusedItemIndex - 1].focus();
                }
              } else {
                if (focusedItemIndex === focusableElements.length - 1) {
                  // 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
                  focusableElements[0].focus();
                } else {
                  // 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
                  focusableElements[focusedItemIndex + 1].focus();
                }
              }
            }
            // ESCキーが押された時
            if (event.key === "Escape") {
              event.preventDefault();
              $container.classList.remove(v);
              setTimeout(() => {
                $container.classList.remove(a);
                $container.remove();
                _target.focus({ preventScroll: true });
              }, 400);
            }
          }
        });
      });
    };
    document.querySelectorAll('.mod-modal').forEach((ele) => {
      ele.addEventListener('click', (e) => {
        let targetKey = e.currentTarget.getAttribute('data-target');
        let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
        if ($content) {
          let closeButton = document.createElement('button');
          closeButton.setAttribute('type', 'button');
          closeButton.className = 'mod-modal-closeBtn';
          closeButton.setAttribute('aria-label', 'close');
          closeButton.innerHTML = '<span aria-hidden="true"></span>';

          $content.appendChild(closeButton);

          let closeArea = document.createElement('div');
          closeArea.className = 'mod-modal-closeArea';
          let containerDiv = document.createElement('div');
          containerDiv.appendChild(closeArea);
          containerDiv.appendChild($content.cloneNode(true));

          createModal(containerDiv.innerHTML, e.currentTarget);
        }
        return false;
      });
    });

    // 画像1個だけのモーダル
    document.querySelectorAll('.mod-modalImg').forEach((ele) => {
      ele.addEventListener('click', (e) => {
        e.preventDefault();
        
        // YouTube動画モーダルの場合
        if (ele.classList.contains('_video')) {
          const youtubeUrl = ele.getAttribute('href');
          if (!youtubeUrl) return false;
          
          // YouTube URLからビデオIDを抽出
          let videoId = '';
          const urlPatterns = [
            /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\?\/]+)/,
            /youtube\.com\/.*[?&]v=([^&]+)/
          ];
          
          for (let pattern of urlPatterns) {
            const match = youtubeUrl.match(pattern);
            if (match && match[1]) {
              videoId = match[1];
              break;
            }
          }
          
          if (!videoId) return false;
          
          const iframeHTML = `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoId}" 
            title="YouTube video player" frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen></iframe>`;
          
          const appendHTML = `<div class="mod-modal-closeArea"></div>
            <button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
            <div class="mod-modalContent_inner _movie">${iframeHTML}</div>`;
          
          createModal(appendHTML, e.currentTarget);
          return false;
        }
        
        // 通常の画像モーダル
        let appendHTML = `<div class="mod-modal-closeArea"></div>
          <button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
          ${e.currentTarget.querySelector('img').outerHTML}`;
        createModal(appendHTML, e.currentTarget);
        return false;
      });
    });
  }

  setModal();
})();

// ニュースルーム 検索ブロック 展開/折りたたみ・クリア
(function() {
  let section = document.querySelector('.newsroom-search');
  if (!section) return;

  const isEnglish = !!section.closest('.inc_newsroom_search_en');
  const labelOpen = isEnglish ? 'Close advanced search' : '詳細を閉じる';
  const labelClosed = isEnglish ? 'Advanced search' : '詳細検索';

  section.querySelectorAll('.js-newsroom-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      let isOpen = section.classList.toggle('is-open');
      section.querySelectorAll('.newsroom-search__toggle-label').forEach(function(lbl) {
        lbl.textContent = isOpen ? labelOpen : labelClosed;
      });
    });
  });

  section.querySelectorAll('.js-newsroom-clear').forEach(function(btn) {
    btn.addEventListener('click', function() {
      section.querySelectorAll('input[type="text"]').forEach(function(i) { i.value = ''; });
      section.querySelectorAll('input[type="checkbox"]').forEach(function(c) { c.checked = false; });
      section.querySelectorAll('select').forEach(function(s) { s.value = ''; });
    });
  });
})();

// カード型カルーセル（トーリーなど）tablet/spで有効
(function() {
  const SLIDES_PER_VIEW = 2;

  function setupCarousel() {
    const grids = document.querySelectorAll('.js-card-carousel');
    if (!grids.length) return;

    const isMobile = window.innerWidth <= 767;

    grids.forEach((grid) => {
      let carouselEl = grid.previousElementSibling?.classList.contains('mod-card-carousel')
        ? grid.previousElementSibling
        : null;
      const isCarouselActive = !!carouselEl;

      // data-slides-per-view 属性でカルーセル単位の表示枚数を指定可能（デフォルト2）
      const slidesPerView = parseInt(grid.dataset.slidesPerView, 10) || SLIDES_PER_VIEW;

      if (isMobile && !isCarouselActive) {
        // カルーセルモード有効化
        let carouselIndex = 0;
        const cards = Array.from(grid.querySelectorAll(':scope > .stories-card, :scope > .mod-boxLink01, :scope > .mod-boxLink03, :scope > span'));

        // カードが表示枚数以下ならカルーセル化せずグリッド表示のまま
        if (cards.length <= slidesPerView) return;

        carouselEl = document.createElement('div');
        carouselEl.className = 'mod-card-carousel';
        carouselEl.dataset.carouselIndex = '0';

        const trackEl = document.createElement('div');
        trackEl.className = 'mod-card-carousel__track';

        cards.forEach(card => {
          const slide = document.createElement('div');
          slide.className = 'mod-card-carousel__slide';
          slide.appendChild(card);
          trackEl.appendChild(slide);
        });

        carouselEl.appendChild(trackEl);

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'mod-card-carousel__btn mod-card-carousel__btn--prev';
        prevBtn.setAttribute('aria-label', '前へ');
        prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_left"></use></svg>';
        prevBtn.addEventListener('click', () => {
          carouselIndex = carouselIndex > 0 ? carouselIndex - 1 : Math.max(0, cards.length - slidesPerView);
          updateCarousel(carouselEl, carouselIndex, cards.length, slidesPerView);
        });

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'mod-card-carousel__btn mod-card-carousel__btn--next';
        nextBtn.setAttribute('aria-label', '次へ');
        nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>';
        nextBtn.addEventListener('click', () => {
          carouselIndex = carouselIndex < cards.length - slidesPerView ? carouselIndex + 1 : 0;
          updateCarousel(carouselEl, carouselIndex, cards.length, slidesPerView);
        });

        carouselEl.appendChild(prevBtn);
        carouselEl.appendChild(nextBtn);

        grid.parentNode.insertBefore(carouselEl, grid);
        grid.style.display = 'none';

        updateCarousel(carouselEl, carouselIndex, cards.length, slidesPerView);

      } else if (isMobile && isCarouselActive) {
        // リサイズ時：px指定の送り量を現在のスライド幅で再計算
        const slides = carouselEl.querySelectorAll('.mod-card-carousel__slide');
        const carouselIndex = parseInt(carouselEl.dataset.carouselIndex, 10) || 0;
        updateCarousel(carouselEl, carouselIndex, slides.length, slidesPerView);

      } else if (!isMobile && isCarouselActive) {
        // グリッド表示に戻す
        const slides = Array.from(carouselEl.querySelectorAll('.mod-card-carousel__slide'));
        slides.forEach(slide => {
          const card = slide.firstElementChild;
          if (card) grid.appendChild(card);
        });
        carouselEl.remove();
        grid.style.display = '';
      }
    });
  }

  function updateCarousel(carouselEl, carouselIndex, totalCards, slidesPerView = SLIDES_PER_VIEW) {
    const trackEl = carouselEl.querySelector('.mod-card-carousel__track');
    if (!trackEl) return;

    carouselEl.dataset.carouselIndex = String(carouselIndex);

    // %指定はトラック幅（padding-right込み）基準で1送りごとに送り過ぎて左端が切れるため、
    // 対象スライドの実位置（px）基準で送る
    const targetSlide = trackEl.children[carouselIndex];
    trackEl.style.transform = `translateX(-${targetSlide ? targetSlide.offsetLeft : 0}px)`;
    const prevBtn = carouselEl.querySelector('.mod-card-carousel__btn--prev');
    const nextBtn = carouselEl.querySelector('.mod-card-carousel__btn--next');

    if (prevBtn) prevBtn.style.display = carouselIndex > 0 ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = carouselIndex < totalCards - slidesPerView ? 'flex' : 'none';

    // 表示中でないスライドはタブ順・支援技術から除外する（WCAG 2.4.11 フォーカスの非遮蔽）
    // 画面外に押し出したカード内のリンクにキーボードフォーカスが当たらないようにする
    const slides = trackEl.querySelectorAll(':scope > .mod-card-carousel__slide');
    slides.forEach((slide, i) => {
      const isVisible = i >= carouselIndex && i < carouselIndex + slidesPerView;
      slide.inert = !isVisible;
      slide.setAttribute('aria-hidden', String(!isVisible));
    });
  }

  window.addEventListener('load', setupCarousel);
  window.addEventListener('resize', setupCarousel);
})();

// ファイルサイズ変換
(function() {
  const bytesToSize = (bytes) => {
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
      return 'n/a';
    }
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) {
      return bytes + ' ' + sizes[i];
    }
    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
  }
  if(document.querySelectorAll('.js-fileSize').length) {
    document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
      pdfElement.innerText = bytesToSize(pdfElement.innerText);
    });
  }
})();

// ページタイトル画像 is-active付与（inview）
window.addEventListener('DOMContentLoaded', function() {
  let el = document.querySelector('.mod-pageTitle._image');
  if (!el) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        observer.unobserve(entry.target);
      }
    });
  });

  observer.observe(el);
});


// TOPページ ヘッダー重要お知らせスクロール制御
(function() {
  const important = document.querySelector('.js-header-important');
  if (!important) return;

  const header = document.querySelector('.site-header');
  if (!header) return;

  function onScroll() {
    const rect = important.getBoundingClientRect();
    if (rect.bottom <= 0) {
      header.classList.add('is-fixed');
    } else {
      header.classList.remove('is-fixed');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();

// 課題1099 / 課題1472: ブラウザバック・リロード時のスクロール位置復元安定化
// TOP ページなど遅延読み込みコンテンツ（IRPocket・カルーセル・緊急のお知らせ）で
// document height が大きく変動するページでも復元位置がズレないよう、
// MutationObserver で DOM 変化を監視しつつ一定時間スクロールを再適用する。
(function() {
  if (!('sessionStorage' in window)) return;
  const KEY = '__scroll:' + location.pathname;

  // ハッシュ遷移時はアンカー位置を優先し、保存済みスクロール復元は無効化する。
  function hasHashTarget() {
    return Boolean(window.location.hash && window.location.hash !== '#');
  }

  function getHeaderOffset() {
    const rootStyles = getComputedStyle(document.documentElement);
    const cssVar = parseFloat(rootStyles.getPropertyValue('--height-header'));
    const header = document.querySelector('.site-header');
    const headerHeight = header ? header.offsetHeight : 60;
    const base = Number.isFinite(cssVar) ? cssVar : headerHeight;
    return base + 16;
  }

  function createUserScrollGuard() {
    let interrupted = false;
    const scrollKeys = new Set([
      'ArrowUp',
      'ArrowDown',
      'PageUp',
      'PageDown',
      'Home',
      'End',
      ' ',
      'Spacebar'
    ]);

    function stop() {
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('keydown', onKeyDown);
    }

    function onWheel() {
      interrupted = true;
      stop();
    }

    function onTouchStart() {
      interrupted = true;
      stop();
    }

    function onKeyDown(event) {
      if (!scrollKeys.has(event.key)) return;
      interrupted = true;
      stop();
    }

    window.addEventListener('wheel', onWheel, { passive: true, once: true });
    window.addEventListener('touchstart', onTouchStart, { passive: true, once: true });
    window.addEventListener('keydown', onKeyDown);

    return {
      isInterrupted: () => interrupted,
      stop,
    };
  }

  function scrollToHashTarget() {
    if (!hasHashTarget()) return;

    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    const y = Math.max(0, window.scrollY + target.getBoundingClientRect().top - getHeaderOffset());
    window.scrollTo({ top: y, behavior: 'instant' });
  }

  function getNavigationType() {
    if (!('performance' in window) || typeof performance.getEntriesByType !== 'function') return '';
    const navEntries = performance.getEntriesByType('navigation');
    if (!navEntries || !navEntries.length) return '';
    return navEntries[0].type || '';
  }

  function shouldRestoreSavedScroll(event) {
    const navType = getNavigationType();
    const isReload = navType === 'reload';
    const isBackForward = navType === 'back_forward';
    const isBfcacheRestore = Boolean(event && event.persisted);
    return isReload || isBackForward || isBfcacheRestore;
  }

  // ブラウザのデフォルト復元と競合しないよう手動制御に切替える
  if ('scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (err) {}
  }

  function applySavedScroll(event) {
    if (hasHashTarget()) return;
    if (!shouldRestoreSavedScroll(event)) return;

    let saved = null;
    try { saved = sessionStorage.getItem(KEY); } catch (err) { return; }
    if (!saved) return;
    const y = parseInt(saved, 10);
    if (isNaN(y) || y <= 0) return;
    const guard = createUserScrollGuard();

    function tryScroll() {
      if (guard.isInterrupted()) return;
      window.scrollTo({ top: y, behavior: 'instant' });
    }
    tryScroll();
    requestAnimationFrame(tryScroll);
    window.addEventListener('load', tryScroll, { once: true });

    // DOM の高さ変動に追従して 2.5 秒間繰り返し再適用
    const observer = new MutationObserver(tryScroll);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      tryScroll();
      observer.disconnect();
      guard.stop();
      try { sessionStorage.removeItem(KEY); } catch (err) {}
    }, 2500);
  }

  function applyHashScroll() {
    if (!hasHashTarget()) return;
    const guard = createUserScrollGuard();

    function tryScrollToHash() {
      if (guard.isInterrupted()) return;
      scrollToHashTarget();
    }

    tryScrollToHash();
    requestAnimationFrame(tryScrollToHash);
    window.addEventListener('load', tryScrollToHash, { once: true });

    // 画像などで高さが変わるケースを考慮して一定時間再適用
    const observer = new MutationObserver(tryScrollToHash);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      tryScrollToHash();
      observer.disconnect();
      guard.stop();
    }, 2500);
  }

  // 復元: pageshow（bfcache 含む）/ 初回 DOMContentLoaded
  window.addEventListener('pageshow', applySavedScroll);
  window.addEventListener('pageshow', applyHashScroll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySavedScroll, { once: true });
    document.addEventListener('DOMContentLoaded', applyHashScroll, { once: true });
  } else {
    applySavedScroll();
    applyHashScroll();
  }

  // 保存: pagehide / beforeunload で現在位置を sessionStorage に書き込む
  function saveScroll() {
    if (hasHashTarget()) return;
    try { sessionStorage.setItem(KEY, String(window.scrollY)); } catch (err) {}
  }
  window.addEventListener('pagehide', saveScroll);
  window.addEventListener('beforeunload', saveScroll);
})();

// ページTOPボタン
(function() {
  const v = 'is-visible';
  let footer = document.querySelector('.site-footer');
  let $pagetop = document.querySelector('.site-footer__pagetop');
  let $content = document.querySelector('.main-content');

  if ($pagetop) {
    let footerPos = footer.offsetTop;
    let stopPos = footerPos - window.innerHeight;

    // ボタン表示状態を更新
    const updatePagetop = () => {
      // ページが短くフッターが最初から表示エリア内にある場合は、スクロールなしでも表示
      if (window.scrollY > 100 || stopPos <= 0) {
        $pagetop.classList.add(v);
      } else {
        $pagetop.classList.remove(v);
      }
    };

    // コンテンツ部分の高さ変化を監視
    const contentObserver = new ResizeObserver(() => {
      footerPos = footer.offsetTop;
      stopPos = footerPos - window.innerHeight;
      updatePagetop();
    });
    contentObserver.observe($content);

    window.addEventListener('scroll', updatePagetop);

    // 初期表示時にも判定
    updatePagetop();
  }
})();
// サイト内検索
(function () {
  let siteSearch = document.querySelector('.js-siteSearch');
  if (siteSearch) {
    var s = document.createElement('script');
    s.src = '/common/js/siteSearch.js';
    document.getElementsByTagName('body')[0].appendChild(s);
  }
    
})();
// サイト内検索窓開閉
(function () {
  const a = 'is-active';
  let siteSearch = document.querySelector('.js-siteSearch');
  if (siteSearch) {
    let siteSearchBtn = document.querySelector('.js-siteSearch-btn');
    siteSearchBtn.addEventListener('click', function (e) {
      siteSearch.classList.toggle(a);
      document.querySelector('.header').classList.toggle('search-open');
    });

    // サイト内検索以外をクリックで閉じる
    document.addEventListener('click', function (e) {
      let target = e.target;

      if (!target.closest('.js-siteSearch') && !siteSearch.contains(target)) {
        siteSearch.classList.remove(a);
        setTimeout(function () {
          document.querySelector('.header').classList.remove('search-open');
        }, 400);
      }
    });
  }
})();
// 言語切り替え
(function () {
  const langSwitch = document.querySelectorAll('.site-header__lang');
  if (!langSwitch.length) return;

  // .site-header__lang の href が「/」なら現在ページは英語、「/en/」なら現在ページは日本語
  const getTargetPath = function (path, isEn) {
    return isEn ? path.replace('/en/', '/') : '/en' + path;
  };
  const getFallbackPath = function (isEn) {
    return isEn ? '/' : '/en/';
  };

  const hasEnglishSpb = !!document.querySelector('.english-global-spb');

  langSwitch.forEach(function (switchBtn) {
    switchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const currentPath = window.location.pathname;
      const search = window.location.search;
      const hash = window.location.hash;
      const langHref = (switchBtn.getAttribute('href') || '').trim();
      const isEn = langHref === '/';
      const targetPath = getTargetPath(currentPath, isEn);
      const fallbackPath = getFallbackPath(isEn);

      const navigate = function (path) {
        window.location.href = path + search + hash;
      };

      if (hasEnglishSpb) {
        navigate(fallbackPath);
        return;
      }

      fetch(targetPath, { method: 'HEAD' })
        .then(function (res) {
          navigate(res.ok ? targetPath : fallbackPath);
        })
        .catch(function () {
          navigate(fallbackPath);
        });
    });
  });
})();
